import React, { Component } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import UserStorageManager from "./UserStorageManager";
import Utils from "../Utils";
import Amplify, { Auth, Storage } from "aws-amplify";
import ProjectPanel from "./ProjectPanel";
import { MUI_STYLES } from "../constants";
import AddProject from "./AddProject";

const styles = MUI_STYLES;
class ControlledExpansionPanels extends React.Component {
  constructor(props) {
    super(props);
    //console.log("controlledExpansionPnelas",props);
    this.state = { expanded: "" };
  }

  componentDidMount() {
    this.loadProjects();
  }
  handleExpandChange = projectData => (value, expanded) => {
    if (this.state.expanded === projectData.projectKey) {
      if (projectData.projectKey === "addProject") {
        Object.assign(projectData, {
          lat: 0,
          lng: 0,
          rot: 0,
          projectName: null
        });
      } else {
        Object.assign(projectData, this.state.db.projects[projectData.index]);
      }
    }
    this.setState({
      expanded: expanded ? projectData.projectKey : false
    });
    //console.log("handle expand change", this.state);
  };

  loadProjects = async () => {
    const { awsStorageConfig } = this.props;
    //console.log("Loading project metadata");
    let currentUserInfo = await Auth.currentUserInfo();
    //console.log("awsStorageConfig",awsStorageConfig);
    this.userMan = new UserStorageManager(Storage, currentUserInfo, awsStorageConfig);
    let db = await this.userMan.loadProjects();
    this.setState({ db: db });
    //console.log("db:", db);
  };

  openModelCallback = async projectData => {
    var address = window.location.origin + '/private-model-viewer' +'?modelname=' + projectData.projectKey  + '&projectname=' + projectData.projectName;

    window.open(address);
    
  };

  saveEditCallback = async projectData => {
    //console.log("save callback new values", projectData);

    await this.userMan.editProject(projectData.projectKey, projectData);
    let db = await this.userMan.loadProjects();
    this.setState({ db: db });;

    //console.log("saved callback", this.state, this.props);
  };

  saveAddCallback = async projectData => {
    //console.log("save callback new values", projectData);

    this.setState({ expanded: false });
    let db = await this.userMan.loadProjects();
    this.setState({ db: db });

    //console.log("saved callback", this.state, this.props);
  };

  removeCallback = async projectData => {
    //console.log("save callback new values", projectData);
    this.setState({ expanded: false });
    await this.userMan.removeProject(projectData.projectKey);
    let db = await this.userMan.loadProjects();
    this.setState({ db: db });
    //console.log("saved callback", this.state, this.props);
  };

  ExistingProjects = () => {
    let projects = [];
    if (!this.state.db || !this.state.db.projects) {
      //console.log("No projects to view", this.state);
      return null;
    }

    for (let i = this.state.db.projects.length - 1; i >= 0; i--) {
      let projectData = Object.assign({}, this.state.db.projects[i]);
      projectData.index = i;

      let project = (
        <ProjectPanel
          expanded={this.state.expanded}
          handleExpandChange={this.handleExpandChange}
          key={projectData.projectKey}
          classes={{}}
          projects={this.state.db.projects[i]}
          projectData={projectData}
          openModelCallback={this.openModelCallback}
          saveEditCallback={this.saveEditCallback}
          removeCallback={this.removeCallback}
        />
      );
      projects.push(project);
    }
    return projects;
  };

  render() {
    const { classes } = this.props;
    const { expanded } = this.state;

    return (
      <div className={classes.root}>
        <AddProject
          expanded={this.state.expanded}
          saveAddCallback={this.saveAddCallback}
          handleExpandChange={this.handleExpandChange}
          awsStorageConfig={this.props.awsStorageConfig}
        />
        {this.ExistingProjects()}
      </div>
    );
  }
}

ControlledExpansionPanels.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(ControlledExpansionPanels);
